import React from 'react';
import { Block, FormBlockLabel as Label, FormTextInput as Input, Heading, Paragraph } from '../../devlink/_Builtin';
import { MortgageFormData, FORM_STEPS } from '../types/mortgage';

interface FormStep2Props {
  formData: Partial<MortgageFormData>;
  errors: Record<string, string>;
  updateFormData: (field: keyof MortgageFormData, value: any) => void;
}

const FormStep2: React.FC<FormStep2Props> = ({ formData, errors, updateFormData }) => {
  const stepInfo = FORM_STEPS[1];

  return (
    <Block>
      <div>
        <Heading tag="h2">{stepInfo.title}</Heading>
        <Paragraph>{stepInfo.description}</Paragraph>
      </div>

      <div>
        <div>
          <Label htmlFor="currentAge">
            Current Age *
          </Label>
          <Input
            value={formData.currentAge?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('currentAge', Number(e.target.value))}
            type="number"
            placeholder="30"
          />
          {errors.currentAge && (
            <span>{errors.currentAge}</span>
          )}
        </div>

        <div>
          <Label htmlFor="retirementAge">
            Anticipated Retirement Age *
          </Label>
          <Input
            value={formData.retirementAge?.toString() || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('retirementAge', Number(e.target.value))}
            type="number"
            placeholder="65"
          />
          {errors.retirementAge && (
            <span>{errors.retirementAge}</span>
          )}
        </div>
      </div>

      <div>
        <Heading tag="h3">Annual Income Breakdown</Heading>
        <div>
          <div>
            <Label htmlFor="employedIncome">
              Employed Income (£) *
            </Label>
            <Input
              value={formData.employedIncome?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('employedIncome', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.employedIncome && (
              <span>{errors.employedIncome}</span>
            )}
          </div>

          <div>
            <Label htmlFor="selfEmployedIncome">
              Self-Employed Income (£) *
            </Label>
            <Input
              value={formData.selfEmployedIncome?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('selfEmployedIncome', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.selfEmployedIncome && (
              <span>{errors.selfEmployedIncome}</span>
            )}
          </div>

          <div>
            <Label htmlFor="pensionIncome">
              Pension Income (£) *
            </Label>
            <Input
              value={formData.pensionIncome?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('pensionIncome', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.pensionIncome && (
              <span>{errors.pensionIncome}</span>
            )}
          </div>
        </div>
      </div>
    </Block>
  );
};

export default FormStep2; 